import get from 'lodash-es/get';

import { dispatchThunk } from 'app/store';
import { scrollToNextQuestion } from 'app/store/data/formsConfig';
import {
  getFormValues,
  getCarData,
  setMessageVisibility,
  getOwnerData,
  getFirstCoownerData,
  getSecondCoownerData,
} from 'app/services/businessFunctionHelpers';
import { ScrollService } from 'app/services/scroll.service';
import { MessagesEnum, FormsEnum, FieldsEnum } from 'app/shared/enums';
import { getCurrentQuestionKey } from 'app/components/FormSection/CurrentQuestion.context';

const makeScrollToNextQuestion = () => {
  const currentQuestionKey = getCurrentQuestionKey();

  if (currentQuestionKey)
    dispatchThunk(
      scrollToNextQuestion(FormsEnum.CalculationForm, currentQuestionKey, true)
    );
};

const makeScrollToMessage = () => {
  ScrollService.scrollToQuestion(FieldsEnum.AdditionalDrivers1LicenseYear);
};

const additionalDrivers = {
  adjustYoungDriverSameAsOwnerMessageVisibility() {
    const { hasAdditionalDrivers } = getCarData();

    if (!hasAdditionalDrivers) {
      setMessageVisibility({
        key: MessagesEnum.YoungDriverSameAsOwner,
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
      return;
    }

    const formValues = getFormValues();
    const additionalDriverBirthDate = get(
      formValues,
      FieldsEnum.AdditionalDrivers1BirthDate
    );
    const additionalDriverLicenseYear = get(
      formValues,
      FieldsEnum.AdditionalDrivers1LicenseYear
    );
    const additionalDriverLicenseMonth = get(
      formValues,
      FieldsEnum.AdditionalDrivers1LicenseMonth
    );
    const ownersData = [];
    const { birthDate, driverLicenseYear, driverLicenseMonth } = getOwnerData();
    ownersData.push([birthDate, driverLicenseYear, driverLicenseMonth]);

    [getFirstCoownerData(), getSecondCoownerData()].forEach(
      ({ birthDate, licenseYear, licenseMonth }) => {
        ownersData.push([birthDate, licenseYear, licenseMonth]);
      }
    );

    const isSameData = ownersData.some(
      ([birthDate, licenseYear, licenseMonth]) =>
        birthDate &&
        birthDate === additionalDriverBirthDate &&
        licenseYear &&
        licenseYear === additionalDriverLicenseYear &&
        licenseMonth === additionalDriverLicenseMonth
    );

    setMessageVisibility({
      key: MessagesEnum.YoungDriverSameAsOwner,
      visible: isSameData,
      formName: FormsEnum.CalculationForm,
    });

    isSameData ? makeScrollToMessage() : makeScrollToNextQuestion();
  },
};

export default additionalDrivers;
